<template>
    <div class="mobile-header">
        <div class="header-top">
            <div class="header-row">
                <div class="logo" @click="handleGoHome">
                    <img :src="systemInfo.system_info ? (baseStaticUrl + systemInfo.system_info.web_logo) : '/static/imgs/logo.png'" :alt="systemInfo.system_info ? systemInfo.system_info.web_name : ''" />
                </div>
                <!-- <div class="site-title" v-if="systemInfo.system_info" @click="handleGoHome">
                    <span class="site-title-main">{{ systemInfo.system_info.web_name_title }}</span>
                </div> -->
                <div class="header-actions">
                    <i class="el-icon-search" @click="showSearch = true"></i>
                    <i class="el-icon-menu" @click="showMenu = true"></i>
                </div>
            </div>
        </div>

        <!-- 搜索抽屉 -->
        <el-drawer
            :visible.sync="showSearch"
            direction="ttb"
            size="auto"
            :show-close="false"
            append-to-body
        >
            <div class="search-drawer">
                <el-input
                    v-model="searchText"
                    placeholder="搜索你想要的课程"
                    clearable
                    @keyup.enter="handleSearch"
                >
                    <template #append>
                        <el-button icon="el-icon-search" @click="handleSearch"></el-button>
                    </template>
                </el-input>
                <div class="hot-search">
                    <span>热门：</span>
                    <span v-for="item in hotSearchList" :key="item.id" @click="fillSearchText(item.keyword)">{{ item.keyword }}</span>
                </div>
            </div>
        </el-drawer>

        <!-- 菜单抽屉 -->
        <el-drawer
            :visible.sync="showMenu"
            direction="rtl"
            size="70%"
            append-to-body
        >
            <div class="menu-drawer">
                <div class="user-info" v-if="isLogin">
                    <i class="el-icon-user-solid"></i>
                    <span>{{ userInfo.username }}</span>
                </div>
                <el-button v-if="!isLogin" type="primary" @click="handleShowLogin" size="small">登录</el-button>
                
                <div class="menu-list">
                    <div class="menu-item" @click="handleGoHome">
                        <i class="el-icon-s-home"></i>
                        <span>首页</span>
                    </div>
                    <div class="menu-item" @click="handleGoUserCenter" v-if="isLogin">
                        <i class="el-icon-user"></i>
                        <span>个人中心</span>
                    </div>
                    <div class="menu-item" @click="handleShowService">
                        <i class="el-icon-service"></i>
                        <span>客服中心</span>
                    </div>
                    <div class="menu-item" @click="logout" v-if="isLogin">
                        <i class="el-icon-switch-button"></i>
                        <span>退出登录</span>
                    </div>
                </div>
            </div>
        </el-drawer>

        <!-- 登录弹窗 -->
        <el-dialog 
            :visible.sync="showLoginModal" 
            width="90%"
            :close-on-click-modal="false"
            append-to-body
        >
            <div class="login-header">
                <div class="login-title">用户登录</div>
            </div>

            <div class="login-type-switch">
                <div :class="{ active: loginType === 'password' }" @click="switchLoginType('password')">
                    密码登录
                </div>
                <div :class="{ active: loginType === 'captcha' }" @click="switchLoginType('captcha')">
                    验证码登录
                </div>
            </div>

            <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef">
                <el-form-item prop="phone">
                    <el-input v-model="loginForm.phone" placeholder="请输入手机号" maxlength="11" clearable @input="clearError('phone')"></el-input>
                </el-form-item>

                <el-form-item v-if="loginType === 'password'" prop="password">
                    <el-input v-model="loginForm.password" type="password" placeholder="请输入密码" show-password clearable @input="clearError('password')"></el-input>
                </el-form-item>

                <el-form-item v-if="loginType === 'captcha'" prop="captcha">
                    <el-row :gutter="10">
                        <el-col :span="14">
                            <el-input v-model="loginForm.captcha" placeholder="验证码" maxlength="4" clearable @input="clearError('captcha')"></el-input>
                        </el-col>
                        <el-col :span="10">
                            <el-button 
                                :disabled="captchaDisabled" 
                                @click="getCaptcha" 
                                class="captcha-btn"
                                :loading="captchaLoading"
                            >
                                {{ captchaText }}
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form-item>

                <el-form-item>
                    <el-checkbox v-model="loginForm.remember">记住密码</el-checkbox>
                </el-form-item>

                <el-form-item>
                    <el-checkbox v-model="loginForm.agree">
                        我已阅读并同意
                        <el-button type="text" class="agree-link" @click.stop="showAgreementDialog = true">《会员须知》</el-button>
                    </el-checkbox>
                </el-form-item>

                <el-button type="primary" @click="handleLogin" :loading="loginLoading" style="width: 100%;">登 录</el-button>
            </el-form>
        </el-dialog>

        <!-- 会员须知弹窗 -->
        <el-dialog
            :visible.sync="showAgreementDialog"
            width="90%"
            :close-on-click-modal="false"
            append-to-body
            class="agreement-dialog"
        >
            <div class="agreement-header">
                <i class="el-icon-user-solid"></i>
                <span>会员须知</span>
            </div>
            <div class="agreement-content" v-html="systemInfo.system_info ? systemInfo.system_info.buy_info : ''"></div>
            <div slot="footer" class="agreement-footer">
                <el-button type="primary" @click="() => { loginForm.agree = true; showAgreementDialog = false; }">我已阅读并同意</el-button>
                <el-button @click="showAgreementDialog = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 客服弹窗 -->
        <el-dialog 
            :visible.sync="showServiceModal" 
            width="90%"
            append-to-body
        >
            <div class="service-content">
                <div class="contact-item" @click="handleCall(systemInfo.system_info?.contact_information)">
                    <i class="el-icon-phone"></i>
                    <div>
                        <div class="label">座机电话</div>
                        <div class="value">{{ systemInfo.system_info?.contact_information || '' }}</div>
                    </div>
                    <i class="el-icon-arrow-right"></i>
                </div>
                <div class="contact-item" @click="handleCall(systemInfo.system_info?.kf_phone)">
                    <i class="el-icon-mobile"></i>
                    <div>
                        <div class="label">手机号码</div>
                        <div class="value">{{ systemInfo.system_info?.kf_phone || '' }}</div>
                    </div>
                    <i class="el-icon-arrow-right"></i>
                </div>
                <div class="contact-item">
                    <i class="el-icon-user"></i>
                    <div>
                        <div class="label">联系客服</div>
                        <div class="value">{{ systemInfo.system_info?.customers || '' }}</div>
                    </div>
                </div>
                <div class="contact-item" @click="handleOpenMap(systemInfo.system_info?.address)">
                    <i class="el-icon-location"></i>
                    <div>
                        <div class="label">办公地址</div>
                        <div class="value">{{ systemInfo.system_info?.address || '' }}</div>
                    </div>
                    <i class="el-icon-arrow-right"></i>
                </div>
                <div class="contact-item" @click="handleEmail(systemInfo.system_info?.email)">
                    <i class="el-icon-message"></i>
                    <div>
                        <div class="label">联系邮箱</div>
                        <div class="value">{{ systemInfo.system_info?.email || '' }}</div>
                    </div>
                    <i class="el-icon-arrow-right"></i>
                </div>
                <div class="contact-item">
                    <i class="el-icon-time"></i>
                    <div>
                        <div class="label">工作时间</div>
                        <div class="value">{{ systemInfo.system_info?.work_time || '' }}</div>
                    </div>
                </div>
                <div class="qrcode-box">
                    <img 
                        :src="systemInfo.system_info ? (baseStaticUrl + systemInfo.system_info.weichat) : ''" 
                        alt="微信客服"
                        @touchstart="handleTouchStart"
                        @touchend="handleTouchEnd"
                        @contextmenu.prevent
                    >
                    <div>长按保存二维码</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Session } from '@/utils/storage';
import { getHotSearch } from '@/api/home';
import { senSms } from '@/api/sms';
import { login, logout } from '@/api/user';

export default {
    name: 'HeaderMobile',
    data() {
        const validatePhone = (rule, value, callback) => {
            if (!value) return callback(new Error('请输入手机号'));
            if (!/^1[3-9]\d{9}$/.test(value)) return callback(new Error('请输入正确的手机号'));
            callback();
        };
        return {
            baseStaticUrl: process.env.VUE_APP_STATIC_URL,
            systemInfo: {},
            isLogin: false,
            userInfo: {},
            Year: '',
            showSearch: false,
            showMenu: false,
            showLoginModal: false,
            showServiceModal: false,
            showAgreementDialog: false,
            loginType: 'password',
            loginForm: { phone: '', password: '', captcha: '', remember: false, agree: false },
            loginRules: {
                phone: [{ validator: validatePhone, trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
            },
            captchaDisabled: false,
            captchaLoading: false,
            captchaText: '获取验证码',
            captchaCountdown: 60,
            loginLoading: false,
            searchText: '',
            hotSearchList: [],
            touchTimer: null
        };
    },
    computed: {
    },
    mounted() {
        this.systemInfo = Session.get('systemConfig') || {};
        this.userInfo = Session.get('userInfo') || {};
        this.Year = new Date().getFullYear();
        this.isLogin = !!Session.get('token');
        this.getHotSearch();
    },
    methods: {
        handleGoHome() {
            if (this.$route.path !== '/mobile') this.$router.push('/mobile');
            this.showMenu = false;
        },
        handleShowLogin() {
            this.showLoginModal = true;
            this.showMenu = false;
        },
        handleGoUserCenter() {
            this.$router.push('/mobile/my');
            this.showMenu = false;
        },
        handleShowService() {
            this.showServiceModal = true;
            this.showMenu = false;
        },
        switchLoginType(type) {
            this.loginType = type;
            this.loginForm.captcha = '';
            this.loginForm.password = '';
            this.$refs.loginFormRef.clearValidate();
        },
        clearError(field) {
            this.$refs.loginFormRef.clearValidate(field);
        },
        getCaptcha() {
            this.$refs.loginFormRef.validateField('phone', (errorMessage) => {
                if (errorMessage) {
                    this.$message.warning(errorMessage);
                } else {
                    this.captchaLoading = true;
                    senSms({ mobile: this.loginForm.phone, event: 'login' }).then(res => {
                        this.captchaLoading = false;
                        if (res.code) {
                            this.captchaDisabled = true;
                            this.$message.success('验证码已发送');
                            const timer = setInterval(() => {
                                this.captchaCountdown--;
                                this.captchaText = `${this.captchaCountdown}s`;
                                if (this.captchaCountdown <= 0) {
                                    clearInterval(timer);
                                    this.captchaDisabled = false;
                                    this.captchaText = '获取验证码';
                                    this.captchaCountdown = 60;
                                }
                            }, 1000);
                        } else {
                            this.$message.error(res.msg || '发送失败');
                        }
                    }).catch(() => {
                        this.captchaLoading = false;
                    });
                }
            });
        },
        handleLogin() {
            this.$refs.loginFormRef.validate().then(() => {
                if (!this.loginForm.agree) {
                    return this.$message.warning('请先阅读并同意《会员须知》');
                }
                this.loginLoading = true;
                const params = {
                    account: this.loginForm.phone,
                    ...(this.loginType === 'password' ? { password: this.loginForm.password } : { captcha: this.loginForm.captcha })
                };
                login(params).then(res => {
                    this.loginLoading = false;
                    if (res.code) {
                        this.$message.success('登录成功');
                        Session.set('token', res.data.userinfo.token);
                        Session.set('userInfo', res.data.userinfo);
                        this.isLogin = true;
                        this.showLoginModal = false;
                    } else {
                        this.$message.error(res.msg || '登录失败');
                    }
                }).catch(err => {
                    this.loginLoading = false;
                    this.$message.error('登录失败，请稍后重试');
                });
            }).catch(() => {});
        },
        logout() {
            this.$confirm('确定要退出登录吗？', '温馨提示', {
                confirmButtonText: '退出',
                cancelButtonText: '取消',
                type: 'warning',
                center: true,
                customClass: 'mobile-confirm'
            }).then(() => {
                logout().then(() => {
                    Session.remove('token');
                    Session.remove('userInfo');
                    this.isLogin = false;
                    this.showMenu = false;
                    this.$message.success('已退出登录');
                });
            }).catch(() => {});
        },
        getHotSearch() {
            getHotSearch().then(res => {
                if (res.code) this.hotSearchList = res.data;
            });
        },
        fillSearchText(text) {
            this.$router.push('/mobile/search?keyword=' + encodeURIComponent(text));
            this.showSearch = false;
        },
        handleSearch() {
            if (!this.searchText.trim()) return this.$message.warning('请输入搜索内容');
            this.$router.push('/mobile/search?keyword=' + encodeURIComponent(this.searchText));
            this.showSearch = false;
        },
        handleCall(phone) {
            if (!phone) return;
            window.location.href = `tel:${phone}`;
        },
        handleEmail(email) {
            if (!email) return;
            window.location.href = `mailto:${email}`;
        },
        handleOpenMap(address) {
            if (!address) return;
            const encodedAddress = encodeURIComponent(address);
            if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                window.location.href = `http://maps.apple.com/?q=${encodedAddress}`;
            } else {
                window.location.href = `https://uri.amap.com/marker?address=${encodedAddress}`;
            }
        },
        handleTouchStart(e) {
            this.touchTimer = setTimeout(() => {
                this.$message.success('请在浏览器中长按图片保存');
            }, 500);
        },
        handleTouchEnd() {
            if (this.touchTimer) {
                clearTimeout(this.touchTimer);
                this.touchTimer = null;
            }
        }
    },
    beforeDestroy() {
        if (this.touchTimer) {
            clearTimeout(this.touchTimer);
        }
    }
};
</script>

<style scoped>
.mobile-header {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
}
.header-top {
    padding: 4px 10px;
}
.header-row {
    display: flex;
    align-items: center;
}
.logo {
    flex: 1;
    min-width: 0;
    overflow: hidden;
}
.logo img {
    height: 58px;
    max-width: 100%;
    object-fit: contain;
    object-position: left center;
}
.site-title {
    flex: 1;
    min-width: 0;
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
}
.site-title-main {
    font-size: 17px;
    font-weight: 700;
    color: #e1251b;
    white-space: nowrap;
    letter-spacing: 1px;
}

.header-actions {
    flex-shrink: 0;
    margin-left: auto;
}
.header-actions i {
    font-size: 22px;
    margin-left: 16px;
    color: #333;
}
.search-drawer {
    padding: 20px;
}
.hot-search {
    margin-top: 15px;
    font-size: 14px;
}
.hot-search span {
    margin-right: 10px;
    color: #666;
}
.menu-drawer {
    padding: 20px;
}
.user-info {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-size: 16px;
}
.user-info i {
    font-size: 24px;
    margin-right: 10px;
}
.menu-list {
    margin-top: 20px;
}
.menu-item {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #f0f0f0;
    font-size: 16px;
}
.menu-item i {
    font-size: 20px;
    margin-right: 10px;
    color: #1890ff;
}
.login-header {
    text-align: left;
    margin-bottom: 20px;
}
.login-title {
    font-size: 20px;
    font-weight: 600;
}
.login-type-switch {
    display: flex;
    margin-bottom: 20px;
    background: #f5f5f5;
    border-radius: 8px;
    padding: 4px;
}
.login-type-switch div {
    flex: 1;
    text-align: center;
    padding: 8px;
    border-radius: 6px;
    cursor: pointer;
}
.login-type-switch .active {
    background: #1890ff;
    color: #fff;
}
.agree-link {
    padding: 0;
    font-size: 13px;
    color: #1890ff;
    height: auto;
    line-height: 1;
    vertical-align: baseline;
}
.agreement-header {
    text-align: center;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: 600;
}
.agreement-header i {
    font-size: 22px;
    color: #1890ff;
    margin-right: 8px;
}
.agreement-content {
    max-height: 50vh;
    overflow-y: auto;
    padding: 0 4px;
    font-size: 14px;
    color: #555;
    line-height: 1.8;
    text-align: left;
}
.agreement-content h4 {
    color: #1f2937;
    margin: 16px 0 8px;
    font-size: 15px;
    font-weight: 600;
}
.agreement-content p {
    margin-bottom: 6px;
}
.agreement-footer {
    text-align: center;
    padding-top: 10px;
}
::v-deep .agreement-dialog .el-dialog__header {
    display: none;
}

/* 验证码按钮美化 */
::v-deep .captcha-btn {
    width: 100%;
    height: 40px;
    background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%) !important;
    border: none !important;
    color: #fff !important;
    font-size: 13px;
    border-radius: 8px;
    font-weight: 500;
    transition: all 0.3s ease;
}
::v-deep .captcha-btn:hover:not(:disabled):not(.is-disabled) {
    background: linear-gradient(135deg, #40a9ff 0%, #1890ff 100%) !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}
::v-deep .captcha-btn.is-disabled,
::v-deep .captcha-btn:disabled {
    background: #d9d9d9 !important;
    color: #999 !important;
    cursor: not-allowed;
}
::v-deep .captcha-btn.is-loading {
    background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%) !important;
    color: #fff !important;
}
::v-deep .captcha-btn span {
    color: inherit !important;
}
::v-deep .captcha-btn .el-icon-loading {
    color: #fff !important;
}
.service-content {
    padding: 10px;
    max-height: 60vh;
    overflow-y: auto;
}
.contact-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    padding: 10px;
    background: #f8f8f8;
    border-radius: 8px;
}
.contact-item > i:first-child {
    font-size: 20px;
    color: #1890ff;
    margin-right: 12px;
    flex-shrink: 0;
}
.contact-item > i:last-child {
    font-size: 16px;
    color: #ccc;
    margin-left: auto;
}
.contact-item > div {
    flex: 1;
}
.contact-item .label {
    font-size: 11px;
    color: #999;
    margin-bottom: 2px;
}
.contact-item .value {
    font-size: 13px;
    color: #333;
}
.qrcode-box {
    text-align: center;
    margin-top: 15px;
    padding-bottom: 10px;
}
.qrcode-box img {
    width: 120px;
    height: 120px;
}
.qrcode-box div {
    margin-top: 8px;
    font-size: 12px;
    color: #666;
}

/* 移动端确认弹窗优化 */
::v-deep .mobile-confirm {
    width: 80% !important;
    border-radius: 12px;
}
::v-deep .mobile-confirm .el-message-box__header {
    padding: 20px 20px 10px;
}
::v-deep .mobile-confirm .el-message-box__title {
    font-size: 18px;
    font-weight: 600;
}
::v-deep .mobile-confirm .el-message-box__content {
    padding: 20px;
    font-size: 15px;
}
::v-deep .mobile-confirm .el-message-box__btns {
    padding: 10px 20px 20px;
}
::v-deep .mobile-confirm .el-button {
    padding: 10px 20px;
    font-size: 15px;
    border-radius: 8px;
}
::v-deep .mobile-confirm .el-button--default {
    background: #f5f5f5;
    border: none;
    color: #666;
}
::v-deep .mobile-confirm .el-button--primary {
    background: #1890ff;
    border: none;
}
</style>
